import { PatientSummaryDto } from '../../types/swaggerTypes'
import { isPostTrialAccessOnlyProgramStatus } from './patientInitialsDisplay'

/**
 * Merges catalogue program status onto patient search rows when the API omits
 * PTA on `programStatus` or sends a non-PTA value (e.g. Open) for exPTA programs.
 */
export function applyCatalogProgramStatusToPatientSummaries(
  patients: PatientSummaryDto[],
  statusByProgramId: ReadonlyMap<number, string>
): PatientSummaryDto[] {
  return patients.map((patient) => {
    if (!patient.programId) {
      return patient
    }

    const catalogStatus = statusByProgramId.get(patient.programId)
    if (!catalogStatus) {
      return patient
    }

    if (isPostTrialAccessOnlyProgramStatus(catalogStatus)) {
      return { ...patient, programStatus: catalogStatus }
    }

    return {
      ...patient,
      programStatus: patient.programStatus ?? catalogStatus
    }
  })
}
